import React from 'react';
import { Link } from 'react-router-dom';
import content from '../data/content';

export default function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero-bg">
        <img
          src="/images/AdobeStock_520187150-p-1600.jpeg"
          alt="IT Consulting"
        />
      </div>
      <div className="hero-content">
        <div className="hero-badge">
          <span className="dot" />
          Offen für neue Projekte 2026
        </div>
        <h1>{content.hero.headline}</h1>
        <p>{content.hero.subline}</p>
        <div className="hero-tags">
          {content.hero.tags.map((tag) => (
            <span key={tag} className="hero-tag">{tag}</span>
          ))}
        </div>
        <div className="hero-actions">
          <a href="#/kontakt" className="btn btn-primary">
            Kontakt aufnehmen
          </a>
          <a href="#services" className="btn btn-outline"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Unsere Leistungen →
          </a>
        </div>

        <div className="hero-team-preview">
          <span className="hero-team-label">Unser Team</span>
          <div className="hero-team-cards">
            {content.team.map((member) => (
              <Link key={member.id} to={`/profil/${member.id}`} className="hero-team-card">
                {member.image ? (
                  <img src={member.image} alt={member.name} className="hero-team-avatar" />
                ) : (
                  <div className="hero-team-avatar-placeholder">
                    {member.name.split(' ').map(n => n[0]).join('')}
                  </div>
                )}
                <div className="hero-team-info">
                  <strong>{member.name}</strong>
                  <span>{member.role}</span>
                </div>
                <span className="hero-team-arrow">→</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
